// Impactos declarados na alteração extraordinária. "Nenhum" é exclusivo.
export const IMPACT_NONE = 'none'

export const EXPECTED_IMPACT_OPTIONS = [
  { value: 'commissions', text: 'Comissões' },
  { value: 'invoicing', text: 'Faturamento' },
  { value: 'kpi_goals', text: 'KPI e Metas' },
  { value: 'accounting_dre', text: 'Contábil/DRE' },
  { value: IMPACT_NONE, text: 'Nenhum' },
]

export const impactLabel = value => {
  const option = EXPECTED_IMPACT_OPTIONS.find(item => item.value === value)

  return option ? option.text : value
}

// Status da revisão da alteração extraordinária pelo backoffice.
export const REVIEW_STATUS_LABELS = {
  pending: 'Pendente',
  in_review: 'Em revisão',
  reviewed: 'Revisada',
  approved: 'Aprovada',
  rejected: 'Reprovada',
}

export const REVIEW_STATUS_VARIANTS = {
  pending: 'light-warning',
  in_review: 'light-info',
  reviewed: 'light-success',
  approved: 'light-success',
  rejected: 'light-danger',
}
